import ViewPayments from "components/PaymentAdmin/ViewPayments";

const PaymentsPage: React.FC = () => {
  return <ViewPayments />;
};

export default PaymentsPage;
